import { useMemo } from "react"
import { OPERATION_MODE } from '@laramie/ui';
import InputUsuario from "../../../components/common/InputUsuario"

import { Accordion, DatePickerCustom, FormError, FormLabel, InputLista } from "../../../components/common"

const Definicion = ({ formValues, handleInputProxy, errorOf, otherValues, params, idUsuarioCreacion, open, onToggle }) => {
    const procedimientoVariablesCount = useMemo(() =>(
        otherValues.procedimientoVariables.filter(x => x.state !== 'r').length
    ), [otherValues.procedimientoVariables])

    return (
        <Accordion title="Definición" open={open} onToggle={onToggle}>
            <div className='row form-basic'>

                <div className="col-12 col-md-6 col-xl-4">
                    <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                    <input
                        name="nombre"
                        type="text"
                        placeholder=""
                        className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                        value={formValues.nombre}
                        onChange={handleInputProxy}
                        disabled={params.mode === OPERATION_MODE.VIEW}
                    />
                    <FormError message={errorOf('nombre')} />
                </div>
                <div className="col-12 col-md-6 col-xl-4">
                    <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                    <input
                        name="descripcion"
                        type="text"
                        placeholder=""
                        className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                        value={formValues.descripcion}
                        onChange={handleInputProxy}
                        disabled={params.mode === OPERATION_MODE.VIEW}
                    />
                    <FormError message={errorOf('descripcion')} />
                </div>
                <div className="col-12 col-md-6 col-xl-2">
                    <FormLabel htmlFor="idTipoTributo" required>Tipo de tributo</FormLabel>
                    <InputLista
                        name="idTipoTributo"
                        placeholder=""
                        className={`form-control ${errorOf('idTipoTributo') ? 'is-invalid' : ''}`}
                        value={formValues.idTipoTributo}
                        onChange={handleInputProxy}
                        lista="TipoTributo"
                        disabled={params.mode === OPERATION_MODE.VIEW || procedimientoVariablesCount > 0}
                    />
                    <FormError message={errorOf('idTipoTributo')} />
                </div>
                <div className="col-12 col-md-6 col-xl-2">
                    <FormLabel htmlFor="idEstadoProcedimiento" required>Estado</FormLabel>
                    <InputLista
                        name="idEstadoProcedimiento"
                        placeholder=""
                        className={`form-control ${errorOf('idEstadoProcedimiento') ? 'is-invalid' : ''}`}
                        value={formValues.idEstadoProcedimiento}
                        onChange={handleInputProxy}
                        lista="EstadoProcedimiento"
                        disabled={params.mode === OPERATION_MODE.VIEW}
                    />
                    <FormError message={errorOf('idEstadoProcedimiento')} />
                </div>
                <div className="col-12 col-md-6 col-xl-2">
                    <label htmlFor="idUsuarioCreacion" className="form-label">Usuario/a de creación</label>
                    <InputUsuario
                        name="idUsuarioCreacion"
                        placeholder=""
                        className="form-control"
                        value={ idUsuarioCreacion }
                        disabled={true}
                    />
                    <FormError />
                </div>
                <div className="col-12 col-md-6 col-xl-2">
                    <label htmlFor="fechaCreacion" className="form-label">Fecha de creación</label>
                    <DatePickerCustom
                        name="fechaCreacion"
                        placeholder=""
                        className="form-control"
                        value={formValues.fechaCreacion}
                        disabled
                    />
                    <FormError />
                </div>
            </div>
        </Accordion>
    )
}

export default Definicion
